// extracted by mini-css-extract-plugin
export default {"container":"container__7c5c66b2","breadcrumbs":"breadcrumbs__7c5c66b2","title":"title__7c5c66b2","pagination":"pagination__7c5c66b2"};